module.exports = __webpack_public_path__ + "img/estufas-electricas.977d85d3.svg";